import {
  getFailActionName,
  getStartActionName,
  getSuccessActionName,
} from "../../core/make-action";
import ViewerMethod from "../../core/ViewerMethod";
import { combineReducers } from "redux";
import { BookmarkRawData, BookmarksState } from "./types";
import { DetailedLoadStatus } from "../../../../../../common/utils/async-status";

const bookmarksRawData = (state: BookmarkRawData[] = [], action) => {
  switch (action.type) {
    case getSuccessActionName(ViewerMethod.GET_BOOKMARKS):
      return action.resultData.sort(bookmarksByPageComparator);
    case getSuccessActionName(ViewerMethod.SET_BOOKMARK):
      return upsert(state, action.resultData);
    case getSuccessActionName(ViewerMethod.DELETE_BOOKMARK):
      return state.filter(
        (bookmark) => bookmark.guid !== action.apiCallArgs[0]?.id
      );
    default:
      return state;
  }
};

const loadStatus = (
  state: DetailedLoadStatus = DetailedLoadStatus.WAITING,
  action
) => {
  switch (action.type) {
    case getStartActionName(ViewerMethod.GET_BOOKMARKS):
      return DetailedLoadStatus.FETCHING;
    case getSuccessActionName(ViewerMethod.GET_BOOKMARKS):
      return DetailedLoadStatus.OK;
    case getFailActionName(ViewerMethod.GET_BOOKMARKS):
      return DetailedLoadStatus.ERROR;
    default:
      return state;
  }
};

function bookmarksByPageComparator(a, b) {
  var aValue = a.page;
  var bValue = b.page;

  // If we can successfully do it, convert string to a number
  if (!isNaN(parseInt(aValue, 10))) {
    aValue = parseInt(aValue, 10);
  } else if (!isNaN(parseInt(bValue, 10))) {
    bValue = parseInt(bValue, 10);
  }

  // Sort alphabetic pages (ex. xxvii) before numeric ones (ex. 93)
  if (isNaN(parseInt(aValue, 10)) && !isNaN(parseInt(bValue, 10))) {
    return -1;
  } else if (isNaN(parseInt(bValue, 10)) && !isNaN(parseInt(aValue, 10))) {
    return 1;
  }

  // Normal compare for either number-to-number or string-to-string
  if (aValue < bValue) {
    return -1;
  } else if (aValue > bValue) {
    return 1;
  } else {
    return 0;
  }
}

const upsert = (state, data) => {
  const exists = !!state.find((bookmark) => data.guid === bookmark.guid);
  if (exists) {
    return state;
  } else {
    return state.concat(data).sort(bookmarksByPageComparator);
  }
};

export default combineReducers<BookmarksState>({
  bookmarksRawData,
  loadStatus,
});
